import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0022b413"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 3,
  class: "menu__controls"
}
const _hoisted_2 = { class: "sidebar-tree-item__dots-icon" }
const _hoisted_3 = { class: "sidebar-tree-item__plus-icon" }
const _hoisted_4 = { class: "sidebar-tree-item__chevron-icon" }
const _hoisted_5 = {
  key: 0,
  class: "menu__submenu"
}

import { computed, inject, nextTick, onMounted, PropType, Ref, ref, watch } from 'vue';
import { RouteLocation, RouterLink, RouterView, useRouter } from 'vue-router';
import { EditQueueModal } from '@/components';
import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmSvg,
} from 'tir-components';
import { EllipsisHorizontalIcon, PlusIcon } from 'tir-style-system/icons/solid';
import { ChevronDownIcon, FolderIcon, ListBulletIcon } from 'tir-style-system/icons/outline';
import { GroupModel, NamespaceModel, QueueTasksModel } from '../models';
import { SidebarAddPopover, SidebarMenuItem, SidebarMorePopover } from '.';
import { TreeItemType } from '../enums';
import TirPmDraggable from '@/components/tir-pm-kanban/src/TirPmDraggable.vue';
import { DragModel } from '@/components/tir-pm-kanban';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { AdapterService } from '../adapter';
import { ProjectModel } from '@/models';

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'sidebar-menu-item',
  props: {
  /** Элемент меню */
  menuItem: {
    type: Object as PropType<NamespaceModel | GroupModel | QueueTasksModel>,
    required: true,
  },
  /** Открыт ли sidebar */
  isSidebarOpen: {
    type: Boolean,
  },
  /** Уровень вложенности меню */
  level: {
    type: Number,
    default: 0,
  },
  /** Актуальная ширина sidebar */
  sidebarWidth: {
    type: Number,
    required: true,
  },
  /** Показывать только иконки */
  showOnlyIcons: {
    type: Boolean,
  },
  /**Статичное отображение сайдбара */
  isStatic: { type: Boolean, default: false },
  /**Есть элемент над которым выполняется какое либо действие */
  haveActionItem: { type: Boolean, default: false },
},
  emits: ["onCreateGroup", "onCreateQueue", "onDeleteNamespace", "onDeleteGroup", "onDeleteQueue", "onUpdateGroup", "onUpdateQueue", "onUpdateNamespace", "onMove", "onEditQueue", "unableDeleteQueue", "unableDeleteGroup", "unableDeleteNamespace", "openNamespace", "openGroup", "openQueue", "update:haveActionItem", "getQueueItems"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

/**Параметры */

/**События */


/**Текущий перетаскиваемый элемент */
const currentDragging = inject('currentDragging') as Ref<DragModel<GroupModel | QueueTasksModel>>;
/**Происходит ли перетаскивание */
const isDrag = inject('isDrag') as Ref<boolean>;
/**Директория над которой перетаскивается элемент */
const currentDragOver = inject('currentDragOver') as Ref<
  NamespaceModel | GroupModel | QueueTasksModel
>;

const adapter = new AdapterService();
/**Id редактируемой очереди */
const editQueue = ref<QueueTasksModel>();
/**Список id групп */
const tempGroupIds = [];
/**Открыт поповер добавления */
const isOpenedAddPopover = ref(false);
/**Открыт поповер доп действий */
const isOpenedMorePopover = ref(false);

/**Переключить флаг открытия поповера доп действий */
const toggleVisibleMorePopover = async (visible: boolean) => {
  isOpenedMorePopover.value = visible;
  if (visible) {
    setTimeout(() => {
      emit('update:haveActionItem', visible);
    });
  } else {
    emit('update:haveActionItem', visible);
  }
};
/**Переключить флаг открытия поповера добавления */
const toggleVisibleAddPopover = async (visible: boolean) => {
  isOpenedAddPopover.value = visible;
  if (visible) {
    setTimeout(() => {
      emit('update:haveActionItem', visible);
    });
  } else {
    emit('update:haveActionItem', visible);
  }
};
/**Состояние ховера */
const isHovered = ref(false);
/**Курсор наведен на container */
const isOver = ref(false);

/**Информация о проекте */
const project = inject('project') as Ref<ProjectModel>;

/**Объект для перетаскивания элемента */
const containerDragModel = computed(
  () =>
    new DragModel({
      Data: props.menuItem,
      AllowDrag: !props.menuItem.isNamespace() && !props.isStatic,
      AllowDrop: true,
    }),
);
/**Видно ли имя параметра */
const nameVisible = computed(() => (props.isSidebarOpen && !props.showOnlyIcons) || props.isStatic);
/**Классы контейнер элемента */
const containerClasses = computed(() => [
  'menu__container',
  { 'menu__container--close': !props.isSidebarOpen },
  { 'is-selected': props.menuItem.isSelectedInSidebar && !props.haveActionItem },
  { 'is-selected-secondary': props.menuItem.isSelectedInSidebar && props.haveActionItem },
  { 'is-active': isOpenedMorePopover.value || isOpenedAddPopover.value },
  { hidden: currentDragging.value?.Data?.Id == props.menuItem.Id },
  {
    over:
      isOver.value && isDrag.value && (props.menuItem.isGroup() || props.menuItem.isNamespace()),
  },
]);
/**Элемент рабочей области */
const namespaceItem = computed(() => (props.menuItem.isNamespace() ? props.menuItem : undefined));
/**Элемент группы */
const groupItem = computed(() => (props.menuItem.isGroup() ? props.menuItem : undefined));
/**Элемент очереди задач */
const queueItem = computed(() => (props.menuItem.isQueue() ? props.menuItem : undefined));

/**Дочерние группы */
const childrenGroups = computed(() => {
  if (namespaceItem.value?.Groups?.length) return namespaceItem.value.Groups;
  if (groupItem.value?.Groups?.length) return groupItem.value.Groups;
  return [];
});

/**Дочерние очереди */
const childrenQueues = computed(() => {
  if (namespaceItem.value?.QueueTasks?.length) return namespaceItem.value.QueueTasks;
  if (groupItem.value?.QueueTasks?.length) return groupItem.value.QueueTasks;
  return [];
});

/**Переход на страницу очереди */
const redirectQueuePage = computed(() => {
  return {
    name: 'queue',
    params: {
      projectId: project.value.Id,
      namespaceId: queueItem.value.NamespaceId,
      queueId: queueItem.value.Id,
    },
  };
});

/**Дочерние элементы */
const childrenItems = computed(() => [...childrenQueues.value, ...childrenGroups.value]);
/**ID очереди */
const namespaceId = computed(() => {
  if (namespaceItem.value) return namespaceItem.value.Id;
  if (groupItem.value) return groupItem.value.NamespaceId;
});
/** Открыто ли вложенное меню */
const isSubmenuOpen = computed({
  get() {
    if (namespaceItem.value) return namespaceItem.value.isOpenInSidebar;
    if (groupItem.value) return groupItem.value.isOpenInSidebar;
    return false;
  },
  set(value) {
    if (namespaceItem.value) return (namespaceItem.value.isOpenInSidebar = value);
    if (groupItem.value) return (groupItem.value.isOpenInSidebar = value);
  },
});
/** Вычисляемый отступ для элемента меню, если он вложен */
const translateXMenuWrapper = computed(() =>
  props.isSidebarOpen ? `translateX(${(props.level * 12) / 16 + 'rem'})` : 'translateX(0rem)',
);

/** Переклюатель видимости вложенного меню */
const toggleSubmenu = (visible?: any | boolean) => {
  isSubmenuOpen.value = typeof visible == 'boolean' ? visible : !isSubmenuOpen.value;
};
/** Ховер для элемента меню */
const toggleHoverMenuItem = (event: MouseEvent, addHover: boolean) => {
  if (!props.isSidebarOpen) return;
  isHovered.value = addHover;

  const target = event.target as HTMLElement | undefined;
  const menuBlock = target?.closest('.menu__container');

  if (!menuBlock) return;

  if (addHover) {
    menuBlock.classList.add('menu__container_hover');
  } else {
    menuBlock.classList.remove('menu__container_hover');
  }
};
const onClick = (event: any) => {
  if (
    event?.target?.closest('.menu__controls') ||
    event?.target?.closest('.sidebar-tree-item__chevron-button')
  )
    return;
  if (namespaceItem.value) {
    const route = router.resolve({
      name: 'namespace',
      params: { namespaceId: namespaceItem.value.Id },
    });
    emit('openNamespace', namespaceItem.value.Id, route);
    return;
  }
  if (groupItem.value) {
    const route = router.resolve({
      name: 'group',
      params: { groupId: groupItem.value.Id, namespaceId: groupItem.value.NamespaceId },
    });
    emit('openGroup', groupItem.value.NamespaceId, groupItem.value.Id, route);
    return;
  }
  if (queueItem.value) {
    localStorage.setItem('queueModel', JSON.stringify(queueItem.value));
    const route = router.resolve({
      name: 'queue',
      params: { queueId: queueItem.value.Id, namespaceId: queueItem.value.NamespaceId },
    });
    emit('openQueue', queueItem.value.NamespaceId, queueItem.value.Id, route);
    return;
  }
};
/**Обработка перетаскивания блока */
const onDrag = (_isDrag: boolean, _dragModel: DragModel<GroupModel | QueueTasksModel>) => {
  isDrag.value = _isDrag;
  if (_isDrag) {
    currentDragging.value = _dragModel;
  } else {
    setTimeout(() => {
      currentDragging.value = undefined;
      currentDragOver.value = undefined;
    });
  }
};
/**Переключение статуса наведения на container */
const onOver = (_isOver: boolean) => {
  if (!checkAllowOver()) {
    isOver.value = false;
    return;
  }

  isOver.value = _isOver;

  if (_isOver && !props.menuItem.isQueue()) {
    currentDragOver.value = props.menuItem;
    if (isDrag.value && !isSubmenuOpen.value && childrenItems.value.length) {
      toggleSubmenu();
    }
  }
};
/**Проверка разрешения наведения */
const checkAllowOver = () => {
  if (!currentDragging.value) return false;

  const item = currentDragging.value.Data;
  if (item.isGroup()) {
    const parentId = item.ParentGroupId || item.NamespaceId;
    const ids = [parentId, item.Id, ...getDeepArrayIds(item.Groups)];
    if (ids.includes(props.menuItem.Id)) return false;
  }

  return true;
};
/**Рекурсивное заполение id групп */
const getDeepArrayIds = (groups: GroupModel[]) => {
  groups?.forEach((item) => {
    if (item?.Id) {
      tempGroupIds.push(item.Id);
    }
    if (item?.Groups?.length) {
      getDeepArrayIds(item.Groups);
    }
  });
  return tempGroupIds;
};
/**Сброс элемента */
const onDrop = (_dragModel: DragModel<GroupModel>) => {
  if (
    props.menuItem.isQueue() ||
    !isDrag.value ||
    !currentDragging.value ||
    !currentDragOver.value ||
    !isOver.value
  ) {
    return;
  }

  emit('onMove');
};
/**
 * * Открытие окна для редактирования очереди
 */
const openEditQueueModal = () => {
  if (props.menuItem.isQueue()) {
    editQueue.value = props.menuItem;
  }
};

watch(
  () => router.currentRoute.value.fullPath,
  () => {
    if (props.menuItem.QueueTasks?.find((x) => x.Id == router.currentRoute.value.params.queueId)) {
      isSubmenuOpen.value = props.menuItem.QueueTasks?.find(
        (x) => x.Id == router.currentRoute.value.params.queueId,
      );
    }
  },
  { immediate: true },
);

const visibleMoreOptions = computed(() => {
  const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);
  const isProjectAdmin = !!project.value.Admins?.some((a) => a.Id == CurrentUser.Id);

  return isOwner || isProjectAdmin || props.menuItem.IsAdminNamespace;
});
/**Вычисляет маршрут для <router-link> в зависимости от текущего элемента */
const computedRoute = computed(() => {
  if (namespaceItem.value) {
    const route = router.resolve({
      name: 'namespace',
      params: { namespaceId: namespaceItem.value.Id },
    });
    if (!props.isStatic) return route;
  }
  if (groupItem.value) {
    const route = router.resolve({
      name: 'group',
      params: { groupId: groupItem.value.Id, namespaceId: groupItem.value.NamespaceId },
    });
    if (!props.isStatic) return route;
  }
  if (queueItem.value) {
    const route = router.resolve({
      name: 'queue',
      params: { queueId: queueItem.value.Id, namespaceId: queueItem.value.NamespaceId },
    });
    if (!props.isStatic) return route;
  }
});

/**
 * * Закрыть окно редактирования очереди
 */
const closeEditQueueModal = () => (editQueue.value = undefined);
/**При создании папки */
const onCreateGroup = (group: GroupModel) => {
  emit('onCreateGroup', group);
  isSubmenuOpen.value = true;
};
/**При создании очереди */
const onCreateQueue = (task: QueueTasksModel) => {
  emit('onCreateQueue', task);
  isSubmenuOpen.value = true;
};
/**Отправка события для открытия рабочей области */
const openNamespace = (namespaceId: string, route: RouteLocation) => {
  emit('openNamespace', namespaceId, route);
};
/**Отправка события для открытия папки */
const openGroup = (namespaceId: string, groupId: number, route: RouteLocation) => {
  emit('openGroup', namespaceId, groupId, route);
};
/**Отправка события для открытия очереди */
const openQueue = (namespaceId: string, queueId: string, route: RouteLocation) => {
  emit('openQueue', namespaceId, queueId, route);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TirPmDraggable, {
      "is-allow-click-delay": "",
      dragModel: containerDragModel.value,
      onDragging: onDrag,
      onOver: onOver,
      onDrop: onDrop,
      onDragstart: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RouterLink), {
          class: _normalizeClass(containerClasses.value),
          to: computedRoute.value,
          onMouseenter: _cache[12] || (_cache[12] = ($event: any) => (toggleHoverMenuItem($event, true))),
          onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (toggleHoverMenuItem($event, false))),
          onClick: onClick,
          onDblclick: toggleSubmenu
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["menu__wrapper", { 'menu__wrapper_open-sidebar': __props.isSidebarOpen }]),
              style: _normalizeStyle({
          transform: `${translateXMenuWrapper.value}`,
          width: __props.isSidebarOpen ? `calc(100% - ${(__props.level * 12) / 16 + 'rem'})` : '2rem',
        })
            }, [
              (namespaceItem.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['sidebar-menu-item__namespace-icon-wrap', { 'is-hover': !__props.isSidebarOpen }])
                    }, [
                      _createVNode(_unref(TirPmSvg), {
                        url: namespaceItem.value.IconUrl,
                        class: "sidebar-menu-item__namespace-icon",
                        color: namespaceItem.value.Color
                      }, null, 8, ["url", "color"])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["menu__title_hidden", { menu__title_visible: nameVisible.value }])
                    }, _toDisplayString(namespaceItem.value.Name), 3)
                  ], 64))
                : (groupItem.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(FolderIcon), { class: "menu__icon" }),
                      _createElementVNode("div", {
                        class: _normalizeClass(["menu__title_hidden", { menu__title_visible: nameVisible.value }])
                      }, _toDisplayString(groupItem.value.Name), 3)
                    ], 64))
                  : (queueItem.value)
                    ? (_openBlock(), _createBlock(_unref(RouterLink), {
                        key: 2,
                        to: redirectQueuePage.value,
                        class: "menu__queue-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ListBulletIcon), { class: "menu__icon" }),
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu__title_hidden", { menu__title_visible: nameVisible.value }])
                          }, _toDisplayString(queueItem.value.Name), 3)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
              (
            __props.isSidebarOpen &&
            !__props.showOnlyIcons &&
            (isHovered.value || __props.menuItem.isSelectedInSidebar || isOpenedAddPopover.value || isOpenedMorePopover.value)
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (!__props.isStatic && visibleMoreOptions.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_unref(TirPmButton), {
                            variant: _unref(TirPmButtonVariantEnum).LinkState,
                            size: _unref(TirPmButtonSizeEnum).Regular,
                            isPressed: isOpenedMorePopover.value,
                            class: "menu__button",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop","prevent"]))
                          }, {
                            leftSlot: _withCtx(() => [
                              _createVNode(_unref(SidebarMorePopover), {
                                position: _unref(PopoverPositionEnum).Bottom,
                                "menu-item": __props.menuItem,
                                onOnDeleteNamespace: _cache[0] || (_cache[0] = ($event: any) => (emit('onDeleteNamespace', $event))),
                                onOnDeleteGroup: _cache[1] || (_cache[1] = ($event: any) => (emit('onDeleteGroup', $event))),
                                onOnDeleteQueue: _cache[2] || (_cache[2] = ($event: any) => (emit('onDeleteQueue', $event))),
                                onUnableDeleteQueue: _cache[3] || (_cache[3] = ($event: any) => (emit('unableDeleteQueue', $event))),
                                onUnableDeleteGroup: _cache[4] || (_cache[4] = ($event: any) => (emit('unableDeleteGroup', $event))),
                                onUnableDeleteNamespace: _cache[5] || (_cache[5] = ($event: any) => (emit('unableDeleteNamespace', $event))),
                                onOnUpdateGroup: _cache[6] || (_cache[6] = ($event: any) => (emit('onUpdateGroup', $event))),
                                onOnUpdateQueue: _cache[7] || (_cache[7] = ($event: any) => (emit('onUpdateQueue', $event))),
                                onOnUpdateNamespace: _cache[8] || (_cache[8] = ($event: any) => (emit('onUpdateNamespace', $event))),
                                onEditQueue: openEditQueueModal,
                                onToggleVisible: toggleVisibleMorePopover
                              }, {
                                target: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_unref(EllipsisHorizontalIcon), { class: "menu__controls-icon" })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["position", "menu-item"])
                            ]),
                            _: 1
                          }, 8, ["variant", "size", "isPressed"]),
                          (__props.menuItem.Type !== _unref(TreeItemType).Queue && namespaceId.value)
                            ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                                key: 0,
                                variant: _unref(TirPmButtonVariantEnum).LinkState,
                                size: _unref(TirPmButtonSizeEnum).Regular,
                                isPressed: isOpenedAddPopover.value,
                                class: "menu__button",
                                onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop","prevent"]))
                              }, {
                                leftSlot: _withCtx(() => [
                                  _createVNode(_unref(SidebarAddPopover), {
                                    position: _unref(PopoverPositionEnum).Auto,
                                    "namespace-id": namespaceId.value,
                                    "parent-group-id": groupItem.value?.Id,
                                    location: __props.menuItem.Type,
                                    onOnCreateGroup: onCreateGroup,
                                    onOnCreateQueue: onCreateQueue,
                                    onToggleVisible: toggleVisibleAddPopover
                                  }, {
                                    target: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_3, [
                                        _createVNode(_unref(PlusIcon))
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["position", "namespace-id", "parent-group-id", "location"])
                                ]),
                                _: 1
                              }, 8, ["variant", "size", "isPressed"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (__props.isSidebarOpen && childrenItems.value.length)
                ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                    key: 4,
                    class: "sidebar-tree-item__chevron-button",
                    variant: _unref(TirPmButtonVariantEnum).LinkState,
                    size: _unref(TirPmButtonSizeEnum).Small,
                    onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop","prevent"]))
                  }, {
                    leftSlot: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(ChevronDownIcon), {
                          class: _normalizeClass(["menu__controls-icon", { 'menu__controls-icon_submenu-open': isSubmenuOpen.value }]),
                          onClick: toggleSubmenu
                        }, null, 8, ["class"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["variant", "size"]))
                : _createCommentVNode("", true)
            ], 6)
          ]),
          _: 1
        }, 8, ["class", "to"])
      ]),
      _: 1
    }, 8, ["dragModel"]),
    (childrenItems.value.length && isSubmenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass([[
        'menu__submenu-wrapper-' + props.level,
        { 'menu__submenu-wrapper_shown': isSubmenuOpen.value },
      ], "menu__submenu-wrapper"])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childrenItems.value, (item, idx) => {
              return (_openBlock(), _createBlock(_unref(SidebarMenuItem), {
                key: idx,
                "menu-item": item,
                "is-sidebar-open": __props.isSidebarOpen,
                level: +props.level + 1,
                sidebarWidth: __props.sidebarWidth,
                showOnlyIcons: __props.showOnlyIcons,
                isStatic: __props.isStatic,
                "have-action-item": __props.haveActionItem,
                onOnDeleteNamespace: _cache[15] || (_cache[15] = ($event: any) => (emit('onDeleteNamespace', $event))),
                onOnDeleteGroup: _cache[16] || (_cache[16] = ($event: any) => (emit('onDeleteGroup', $event))),
                onOnDeleteQueue: _cache[17] || (_cache[17] = ($event: any) => (emit('onDeleteQueue', $event))),
                onOnCreateGroup: _cache[18] || (_cache[18] = ($event: any) => (emit('onCreateGroup', $event))),
                onOnCreateQueue: _cache[19] || (_cache[19] = ($event: any) => (emit('onCreateQueue', $event))),
                onOnUpdateGroup: _cache[20] || (_cache[20] = ($event: any) => (emit('onUpdateGroup', $event))),
                onOnUpdateQueue: _cache[21] || (_cache[21] = ($event: any) => (emit('onUpdateQueue', $event))),
                onOnUpdateNamespace: _cache[22] || (_cache[22] = ($event: any) => (emit('onUpdateNamespace', $event))),
                onOnMove: _cache[23] || (_cache[23] = ($event: any) => (emit('onMove'))),
                onUnableDeleteQueue: _cache[24] || (_cache[24] = ($event: any) => (emit('unableDeleteQueue', $event))),
                onUnableDeleteGroup: _cache[25] || (_cache[25] = ($event: any) => (emit('unableDeleteGroup', $event))),
                onUnableDeleteNamespace: _cache[26] || (_cache[26] = ($event: any) => (emit('unableDeleteNamespace', $event))),
                onOpenNamespace: openNamespace,
                onOpenGroup: openGroup,
                onOpenQueue: openQueue,
                "onUpdate:haveActionItem": _cache[27] || (_cache[27] = ($event: any) => (emit('update:haveActionItem', $event)))
              }, null, 8, ["menu-item", "is-sidebar-open", "level", "sidebarWidth", "showOnlyIcons", "isStatic", "have-action-item"]))
            }), 128))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(EditQueueModal), {
      queue: editQueue.value,
      onClose: closeEditQueueModal
    }, null, 8, ["queue"])
  ], 64))
}
}

})